import { Accept } from 'react-dropzone';

import { HELP_CENTER_IMPORT_TEMPLATES } from 'shared/help-center';

export type ImportTemplateType = 'own_input' | 'own_composition' | 'budget';

export const importAccept: Accept = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
    '.xlsx',
  ],
  'text/csv': ['.csv'],
};

const importTemplateIdByType: Record<ImportTemplateType, string> = {
  budget: 'budget-template',
  own_composition: 'composition-template',
  own_input: 'input-template',
};

export const getAcceptedExtensionsLabel = (accept: Accept): string => {
  return getAcceptedExtensions(accept).join(', ');
};

export const getAcceptedExtensions = (accept: Accept): string[] => {
  return [...new Set(Object.values(accept).flat())];
};

export const getImportTemplateByType = (
  type: ImportTemplateType,
): (typeof HELP_CENTER_IMPORT_TEMPLATES)[number] | undefined => {
  return HELP_CENTER_IMPORT_TEMPLATES.find(
    (template) => template.id === importTemplateIdByType[type],
  );
};
